/**
 * "What's new" announcement content for the AI assistant (#1618).
 *
 * The webapp owns titles/bodies (i18n) and the backend owns release date + rollout
 * percent. Adding a new announcement is a five-file change (this file + the backend
 * catalog + three translation files) — see README_Announcements.md at the repo root
 * for the walkthrough. Ids must match webapi/Services/Announcements/AnnouncementCatalog.cs;
 * a webapp-only entry is never eligible (the server filter never sees it), a backend-only
 * entry shows no banner (this catalog filter drops it).
 */
export interface Announcement {
    /** Stable identifier shared with backend. Use a slug + month, e.g. "stop-button-2026-05". */
    id: string;
    /** i18n key for the banner title. */
    titleKey: string;
    /** i18n key for the banner body (1-2 sentences). */
    bodyKey: string;
}

export const ANNOUNCEMENTS: Announcement[] = [
    {
        id: 'stop-button-2026-05',
        titleKey: 'announcements.stop-button-2026-05.title',
        bodyKey: 'announcements.stop-button-2026-05.body',
    },
];

export const findAnnouncement = (id: string): Announcement | undefined => ANNOUNCEMENTS.find((a) => a.id === id);
